import styles from "./SampleList.module.css";
import PropTypes from "prop-types";
import { SampleListItem } from "./SampleListItem/SampleListItem";
import { useTranslation } from "react-i18next";
import { samplePropType } from "shared/propTypes";

export function SampleList({ samples, onEditSubmit, onDelete }) {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      {samples == null || samples.length === 0 ? (
        <span className={styles.noSamples}>
          {t("labels.sampleListEmptyLabel")}
        </span>
      ) : (
        <table className={styles.table}>
          <thead>
            <tr>
              <th>{t("labels.productsSampled")}</th>
              <th>{t("labels.sampleLiked")}</th>
              <th>{/* Button Column */}</th>
            </tr>
          </thead>
          <tbody>
            {samples.map((data, i) => (
              <SampleListItem
                key={i}
                sample={data}
                onEditSubmit={onEditSubmit}
                onDelete={onDelete}
              />
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

SampleList.propTypes = {
  /**
   * Array of sample records.
   */
  samples: PropTypes.arrayOf(samplePropType).isRequired,

  /**
   * Callback function to handle submission of an edited sample.
   */
  onEditSubmit: PropTypes.func,

  /**
   * Callback function to handle deleting of a sample.
   */
  onDelete: PropTypes.func,
};
